/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CurriculumOneIcon = /*#__PURE__*/ createSvgIcon(
  'CurriculumOneIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 2.5h4.77c1.517 0 2.366.6 2.809 1.283a2.693 2.693 0 01.42 1.31l.001.01v.006L8 5.11h.5v9.17l-1 .018a1.79 1.79 0 00-2.016-1.712l-.032.004H.5V2.5zm7 2.614v-.006a1.531 1.531 0 00-.031-.222 1.694 1.694 0 00-.23-.56c-.24-.37-.756-.826-1.969-.826H1.5v8.09h3.89a2.79 2.79 0 012.11.63V5.114z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.921 3.783C8.364 3.1 9.213 2.5 10.73 2.5h4.77v10.09h-4.952l-.032-.004A1.79 1.79 0 008.5 14.298l-1-.018V5.11H8h-.5v-.017a1.3 1.3 0 01.007-.12 2.693 2.693 0 01.414-1.19zM8.5 5.11l.003-.044a1.694 1.694 0 01.258-.739c.24-.37.756-.826 1.969-.826h3.77v8.09h-3.89a2.79 2.79 0 00-2.11.63V5.11z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 3h5.99c1.907 0 2.95.75 3.49 1.583a3.314 3.314 0 01.519 1.575v.034l.001.01v.007l-.5.001h.5V18h-1v0-.012l-.005-.067a2.585 2.585 0 00-.34-1.072c-.324-.547-.988-1.159-2.475-1.159H.5V3zm9 12.683V6.2l-.005-.061a2.315 2.315 0 00-.354-1.013C8.805 4.606 8.094 4 6.49 4H1.5v10.69h5.18c1.345 0 2.239.427 2.82.993z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.02 4.583C10.56 3.75 11.602 3 13.51 3h5.99v12.69h-6.18c-1.487 0-2.151.612-2.475 1.16a2.582 2.582 0 00-.345 1.138v.014S10.5 18 10 18h-.5V6.21h.5-.5v-.018a1.53 1.53 0 01.009-.145 3.315 3.315 0 01.51-1.464zm.48 1.63V6.2l.005-.061a2.316 2.316 0 01.354-1.013C11.195 4.606 11.906 4 13.51 4h4.99v10.69h-5.18c-1.345 0-2.239.427-2.82.993v-9.47z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.5 3h7.22c2.293 0 3.53.903 4.165 1.89A3.96 3.96 0 0112.5 6.76v.04l.001.011v.007l-.5.001h.5v14.4h-1v-.02l-.006-.086a3.295 3.295 0 00-.426-1.357c-.41-.703-1.244-1.467-3.068-1.467H.5V3zm11 15.654V6.822 6.804l-.006-.08a2.958 2.958 0 00-.449-1.292c-.434-.675-1.338-1.432-3.325-1.432H1.5v13.29H8c1.736 0 2.83.605 3.5 1.364z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.115 4.89C12.75 3.902 13.987 3 16.28 3h7.218l.054 15.29H16.05c-1.852 0-2.699.767-3.113 1.47A3.267 3.267 0 0012.5 21.2l-.001.018-.5.001h-.5V6.82h.5-.5V6.8a1.68 1.68 0 01.01-.168 3.96 3.96 0 01.604-1.742zm.385 1.932V6.804l.006-.08a2.958 2.958 0 01.449-1.292c.434-.675 1.338-1.432 3.325-1.432h6.222l.046 13.29H16.05c-1.765 0-2.873.611-3.55 1.377V6.821z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CurriculumOneIcon;
